import React, { useEffect, useState } from "react";
import useInViewPort from "./useInViewPort";
import "../styles/youtube_gif.scss";
import { extractYoutubeId, buildEmbedUrl } from "../utils/youtube";

// Native iframe replacement for the gif-style autoplay loop. No react-player.
// Only mounts the iframe once the element scrolls into view, so off-screen
// videos cost nothing.

const YoutubeGif = ({ url = "" }) => {
  const [nodeRef, isVisible] = useInViewPort();
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShowComponent(true);
    }
  }, [isVisible]);

  const videoId = extractYoutubeId(url);
  const embedUrl = buildEmbedUrl(videoId, {
    autoplay: true,
    mute: true,
    loop: true,
    controls: false,
  });

  return (
    <div ref={nodeRef} className={`youtube-gif`}>
      {showComponent ? (
        <iframe
          className="react-player"
          src={embedUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video"
        />
      ) : null}
      <div className="source_label">{url}</div>

      <div className="youtube-gif-overlay"></div>
    </div>
  );
};

export default YoutubeGif;
